// getFilterGroupMap.js
'use strict';
import { List } from 'immutable';
import createCachedSelector from '../resource/createCachedSelector.js';

import getRemoteConfigData, {
  getMergedRemoteConfig,
} from '../selector/getRemoteConfigData.js';

/**
 * Select filter group map
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @param {string} filterType - filter type.
 * @return {object} Return filter group map.
 */
const getFilterGroupMap = createCachedSelector(
  state => getMergedRemoteConfig(state),
  (state, filterType = 'v1') =>
    getRemoteConfigData(
      state,
      `LIVESTREAM_FEED_FILTER_${filterType.toUpperCase()}_LIST`
    ),
  (remoteConfigMap, filterGroups) => {
    if (!filterGroups) return {};

    return filterGroups.reduce((acc, filterGroup) => {
      const raw = remoteConfigMap.get(filterGroup);
      const filters = List.isList(raw) ? raw.toJS() : raw?.split(' ') || [];

      return filters.length > 0 ? { ...acc, [filterGroup]: filters } : acc;
    }, {});
  }
)((state, filterType) => `${filterType}`);

export default getFilterGroupMap;
